module.exports = __webpack_public_path__ + "img/emoji/aww.aad5f02922743dc18ccac2f87f200134.png";